export const staticRouter = [
    {
        path: '/home',
        component: () => import('@/pages/index/index')
    },
    {
        path: '/login',
        component: () => import('@/pages/login/index')
    },
    {
        path: '/dataCenterScreen',
        component: () => import('@/pages/dataCenterScreen/index')
    },
    {
        path: '/tourismPublicOpinionScreen',
        component: () => import('@/pages/tourismPublicOpinionScreen/index')
    },
    {
        path: '/behaviorPortraitScreen',
        component: () => import('@/pages/behaviorPortraitScreen/index')
    },
    {
        path: '/historyPassengerScreen',
        component: () => import('@/pages/historyPassengerScreen/index')
    },
    {
        path: '/passengerFlowAnalysisScreen',
        component: () => import('@/pages/passengerFlowAnalysisScreen/index'),
    },
    {
        path: '/realTimeMonitoringScreen',
        component: () => import('@/pages/realTimeMonitoringScreen/index')
    },
    {
        path: '/satisfactionScreen',
        component: () => import('@/pages/satisfactionScreen/index')
    },
    {
        path: '/spreadAnalysisScreen',
        component: () => import('@/pages/spreadAnalysisScreen/index')
    },
    {
        path: '/bigDataAnalysis',
        component: () => import('@/pages/bigDataAnalysisV3/index')
    },
    {
        path: '/raftManagement',
        component: () => import('@/pages/raftManagement/index')
    },
    {
        path: '/predictionInterface',
        component: () => import('@/pages/predictionInterface/index')
    },
    {
        path: '/tripBigdata',
        beforeEnter: (to, from, next) => {
            window.open('http://113.108.88.51:8083/#/home', '_blank');  // 在新标签页中打开外部 URL
            next(false);  // 确保后续的导航被执行
        }
    },
    {
        path: '/serviceMonitor',
        beforeEnter: (to, from, next) => {
            window.open('http://14.116.154.122:7018/#/bigDataAnalysis', '_blank');  // 在新标签页中打开外部 URL
            // window.open('http://127.0.0.1:3333/#/bigDataAnalysis', '_blank');  // 在新标签页中打开外部 URL
            next(false);  // 确保后续的导航被执行
        }
    },
    {
        path: '/carMonitor',
        component: () => import('@/pages/carMonitor/index')
    },
    // {
    //     path: '/dm',
    //     component: () => import('@/pages/bigDataAnalysis/m3u8Demo')
    // },
    // {
    //     path: '/home1',
    //     component: () => import('@/pages/bigDataAnalysisV2/netLinkChart')
    // },
    {
        path: '/',
        redirect: '/home'
    },
]
export const errorRouter = [
    {
        path: "/403",
        name: "403",
        component: () => import("@/components/ErrorMessage/403.vue"),
        meta: {
            title: "403页面"
        }
    },
    {
        path: "/404",
        name: "404",
        component: () => import("@/components/ErrorMessage/404.vue"),
        meta: {
            title: "404页面"
        }
    },
    {
        path: "/500",
        name: "500",
        component: () => import("@/components/ErrorMessage/500.vue"),
        meta: {
            title: "500页面"
        }
    },
    // Resolve refresh page, route warnings
    {
        path: "/:pathMatch(.*)*",
        component: () => import("@/components/ErrorMessage/404.vue")
    }
]